import React from 'react';
import { flowRight as compose } from 'lodash';
import { ReactChildrenPropType } from '../../lib/commonPropTypes';

class AutoCompleteUnconnected extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: []
    };
  }

  searchCustomers = () => {
    Promise.resolve().then(() => {
      this.setState({
        suggestions: [
          {
            name: 'customer 1',
            id: '1'
          },
          {
            name: 'customer 2',
            id: '2'
          },
          {
            name: 'customer 3',
            id: '3'
          },
          {
            name: 'customer 4',
            id: '4'
          }
        ]
      });
    });
  };

  adminSearchProperties = () => {
    Promise.resolve().then(() => {
      this.setState({
        suggestions: [
          {
            name: 'property 1',
            id: '1'
          },
          {
            name: 'property 2',
            id: '2'
          },
          {
            name: 'property 3',
            id: '3'
          },
          {
            name: 'property 4',
            id: '4'
          }
        ]
      });
    });
  };

  searchUsers = () => {
    Promise.resolve().then(() => {
      const results = [
        {
          firstName: 'John',
          lastName: 'Smith',
          emailAddress: 'john.smith@test.com',
          id: '11231231'
        },
        {
          firstName: 'Jack',
          lastName: 'Doe',
          emailAddress: 'jack.doe@test.com',
          id: '212341234'
        },
        {
          firstName: 'Jenny',
          lastName: 'White',
          emailAddress: 'jenny.white@test.com',
          id: '312341234'
        },
        {
          firstName: 'Alice',
          lastName: 'Dandy',
          emailAddress: 'alice.dandy@test.com',
          id: '412341234'
        }
      ];

      this.setState({ suggestions: results });
    });
  };

  getMutations = () => ({
    searchCustomers: this.searchCustomers,
    searchProperties: this.adminSearchProperties,
    searchUsers: this.searchUsers
  });

  render() {
    const { children } = this.props;
    const { suggestions } = this.state;

    const renderProps = {
      suggestions,
      mutations: this.getMutations()
    };

    return children(renderProps);
  }
}

AutoCompleteUnconnected.propTypes = {
  children: ReactChildrenPropType.isRequired
};

export const AutoCompleteContainer = compose()(AutoCompleteUnconnected);
